import JulesRocket from "components/marketing/home/svgs/JulesRocket";
import Button from "hardcover-ui/components/Button";

export default function PricingLink() {
  return (
    <Button
      as={{
        element: "link",
        props: {
          href: "/supporter",
        },
      }}
      variant="tertiary"
      size="md"
      className="font-semibold  group"
    >
      <JulesRocket className="w-16 -m-6 -ml-5 saturate-50 group-hover:saturate-100" />
      Subscribe
    </Button>
  );
}
